var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"viewOpenpaySuccess"}},[_c('big',[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('h1',[_vm._v("Pago recibido exitosamente")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }